module.exports = __webpack_public_path__ + "img/brand1.1d5855a2.png";